require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./polytechnique-de-montral-2-5-2-2.json") })
        }
      }, "path---polytechnique-de-montral-2-5-2-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---polytechnique-de-montral-2-5-2-2!./.cache/json/polytechnique-de-montral-2-5-2-2.json
// module id = 527
// module chunks = 231608221292675